import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../QuizTaker.css';

interface QuizScore {
  correct: number;
  total: number;
}

interface QuizStats {
  totalAnswered: number;
  totalCorrect: number;
  totalIncorrect: number;
  accuracy: number;
  studyBankCount: number;
}

interface QuizResultsProps {
  score: QuizScore;
  stats: QuizStats;
  onRetryQuiz: () => void;
  onConfigureNewQuiz: () => void;
  onClearProgress: () => void;
}

const QuizResults: React.FC<QuizResultsProps> = ({
  score,
  stats,
  onRetryQuiz,
  onConfigureNewQuiz,
  onClearProgress
}) => {
  const navigate = useNavigate();

  return (
    <div className="content-container">
      <div className="results-container">
        <h2>Quiz Complete!</h2>
        <div className="score-display">
          <p>Your Score: {score.correct} out of {score.total}</p>
          <p>Percentage: {Math.round((score.correct / score.total) * 100)}%</p>
        </div>

        <div className="progress-overview">
          <h3>Overall Progress</h3>
          <div className="progress-stats">
            <div className="stat-item">
              <span className="stat-label">Total Answered:</span>
              <span className="stat-value">{stats.totalAnswered}</span>
            </div>
            <div className="stat-item">
              <span className="stat-label">Correct:</span>
              <span className="stat-value correct">{stats.totalCorrect}</span>
            </div>
            <div className="stat-item">
              <span className="stat-label">Incorrect:</span>
              <span className="stat-value incorrect">{stats.totalIncorrect}</span>
            </div>
            <div className="stat-item">
              <span className="stat-label">Accuracy:</span>
              <span className="stat-value">{stats.accuracy}%</span>
            </div>
            <div className="stat-item">
              <span className="stat-label">Study Bank:</span>
              <span className="stat-value">{stats.studyBankCount} questions</span>
            </div>
          </div>
        </div>

        <div className="action-buttons">
          <button onClick={onRetryQuiz} className="btn btn-primary">
            Take Quiz Again
          </button>
          <button onClick={() => navigate('/study-bank')} className="btn btn-secondary">
            View Study Bank ({stats.studyBankCount})
          </button>
          <button onClick={onConfigureNewQuiz} className="btn btn-secondary">
            Configure New Quiz
          </button>
          <button onClick={onClearProgress} className="btn btn-danger">
            Clear All Progress
          </button>
        </div>
      </div>
    </div>
  );
};

export default QuizResults; 